// 首页轮播图相关api
import base from '~/api/base' // 导入域名配置
import axios from '~/utils/axios' // 导入http中创建的axios实例
import qs from 'qs' // post、put、patch的json序列化工具

const swipeItem = {

  // 免登录-获取所有轮播图
  findAll() {
    return axios.get(`${base.host}/swipeItems`)
  },

  // 管理员-创建轮播图
  create(params) {
    return axios.post(`${base.host}/swipeItems`, qs.stringify(params))
  },

  // 管理员-修改轮播图
  update(swipeItemId, params) {
    return axios.put(`${base.host}/swipeItems/${swipeItemId}`, qs.stringify(params))
  },

  // 管理员-删除轮播图
  delete(swipeItemId) {
    return axios.delete(`${base.host}/swipeItems/${swipeItemId}`)
  }
}

export default swipeItem
